// loaderSlice.ts
import { createSlice } from "@reduxjs/toolkit";

interface CommonProps {
    contract_id: string;
    contract_worspace: string;
  }
  
  interface CommonPropsObj {
    workspacePayload: CommonProps;
  }
 
  const initialState: CommonPropsObj = {
    workspacePayload: {
      contract_id: '',
      contract_worspace: ''
    },
  };
 
const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setWorkspaceInStrore(state, action) {
      state.workspacePayload = action.payload;
    },
    
  },
});

export const { setWorkspaceInStrore } = commonSlice.actions;
export default commonSlice.reducer;
